<div class="wrapper-md">
    <app-breadcrumbs [items]="[{ url: '/course-equalizations', text: 'courseEqualization_listTitle' }]"></app-breadcrumbs>

    <header class="content-header">
        <h1>{{'courseEqualization_listTitle' | translate}}</h1>
        <aside>
            <button type="button" class="btn btn-outline" (click)="toggleStudentPicker()" *ngIf="!studentPickerOpened && (canPickStudent || student)">
                <i class="fi fi-rs-user"></i>
                {{'courseEqualization_btnPickStudent' | translate}}
            </button>

            <button type="button" class="btn btn-outline-primary" *ngIf="canEdit && !studentPickerOpened" [routerLink]="['/course-equalizations/add'] | localize">
                <i class="fi fi-rs-plus"></i>
                {{'add' | translate}}
            </button>
        </aside>
    </header>

    <app-person-picker *ngIf="studentPickerOpened" (pick)="setStudent($event)"></app-person-picker>

    <ng-container *ngIf="!studentPickerOpened">
        <div class="data-value" *ngIf="canPickStudent && student">
            <label>{{'courseEqualization_lblStudent' | translate}}</label>
            <div>{{student.FirstName}} {{student.LastName}}, {{student.Email}}</div>
        </div>

        <app-table [rows]="items" [columns]="columns" *ngIf="!canPickStudent || student">
            <ng-template #rowTemplate let-row>
                <tr>
                    <td class="hidden-sm-down">
                        <app-course-equalization-status [value]="row.Status"></app-course-equalization-status>
                    </td>
                    <td class="hidden-md-up">
                        <div>
                            <app-course-equalization-status [value]="row.Status"></app-course-equalization-status>
                        </div>
                        <div class="">{{row.Speciality}} ({{row.StudyYear}})</div>
                        <div class="text-sub">{{row.Created | appDate}}</div>
                    </td>
                    <td class="hidden-sm-down hidden-lg-up">
                        <div>{{row.Speciality}} ({{row.StudyYear}})</div>
                        <div class="text-sub">{{row.Created | appDate}}</div>
                    </td>
                    <td class="hidden-md-down">{{row.Speciality}}</td>
                    <td class="hidden-md-down">{{row.StudyYear}}</td>
                    <td class="hidden-md-down">{{row.Created | appDate}}</td>
                    <td>
                        <div class="table-actions">
                            <button type="button" (click)="delete(row)" *ngIf="canDelete(row)" class="btn btn-outline-primary btn-icon"
                                    [ngbTooltip]="'delete' | translate">
                                <i class="fi fi-rs-trash"></i>
                            </button>

                            <button type="button" class="btn btn-outline btn-icon" [routerLink]="['/course-equalizations', row.Id] | localize"
                                    [ngbTooltip]="'open' | translate">
                                <i class="fi fi-rs-pencil"></i>
                            </button>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </app-table>
    </ng-container>

    <section class="block" *ngIf="canPickStudent">
        <header class="block-header">
            <h5>{{'courseEqualization_assigned' | translate}}</h5>
        </header>

        <form #assignedForm="ngForm">
            <div class="row">
                <div class="col-md form-field">
                    <app-date name="assignedDateFrom"
                              [(ngModel)]="assignedDateFrom"
                              [placeholder]="'courseEqualization_lblAssignedDateFrom' | translate"
                              (dateChange)="loadAssigned()"></app-date>
                </div>

                <div class="col-md form-field">
                    <app-date name="assignedDateTo"
                              [(ngModel)]="assignedDateTo"
                              [placeholder]="'courseEqualization_lblAssignedDateTo' | translate"
                              (dateChange)="loadAssigned()"></app-date>
                </div>

                <div class="col-md form-field">
                    <app-select name="assignedStatus"
                                [(ngModel)]="assignedStatus"
                                [placeholder]="'courseEqualization_lblAssignedStatus' | translate"
                                [options]="assignedStatusOptions"
                                [multiple]="true"
                                [displayFn]="statusDisplayFn"></app-select>
                </div>

                <div class="col-md form-field">
                    <input class="form-control"
                           [placeholder]="'courseEqualization_lblSearchAssigned' | translate"
                           [(ngModel)]="assignedSearch"
                           name="assignedSearch" />
                </div>
            </div>
        </form>

        <app-table [rows]="assignedItems" [columns]="assignedColumns">
            <ng-template #rowTemplate let-row>
                <tr>
                    <td>
                        {{row.Name}} {{row.Surname}}
                        <div class="text-sub">{{row.Email}}</div>
                        <div class="hidden-sm-up mt-1">
                            <app-course-equalization-status [value]="row.Status"></app-course-equalization-status>
                        </div>
                    </td>
                    <td class="hidden-md-down">{{row.Speciality}}</td>
                    <td class="hidden-sm-down">{{row.StudyYear}}</td>
                    <td class="hidden-xs-down">{{row.Created | appDate}}</td>
                    <td class="hidden-xs-down">
                        <app-course-equalization-status [value]="row.Status"></app-course-equalization-status>
                    </td>
                    <td>
                        <div class="table-actions">
                            <button type="button" class="btn btn-outline btn-icon" [routerLink]="['/course-equalizations', row.Id] | localize"
                                    [ngbTooltip]="'open' | translate">
                                <i class="fi fi-rs-pencil"></i>
                            </button>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </app-table>
    </section>
</div>
